const dashboard = {
    title: String("Tauler principal"),
    noModulesFound: String("Encara no s'ha registrat cap estació. Aneu a la secció de estacions per registrar la vostra primera estació."),
    loadingModules: String("Espereu mentre es carrega la informació de les estacions ..."),
    mapOverlayBoxTitle: String("Seleccioneu l'estació"),
    mapOverlayBoxTemperature: String("Temperatura"),
    mapOverlayBoxRelHumidity: String("Humitat Relativa"),
    mapOverlayBoxRainmeter: String("Pluviometria"),
    noDataForModule: String("Avui, l'informació d'aquesta estació encara no s'ha rebut."),
};

export default dashboard;